export const GET_UNDELIVERED_MESSAGES_PENDING = 'GET_UNDELIVERED_MESSAGES_PENDING'
export const LOAD_UNDELIVERED_MESSAGES_SUCCESSFUL = 'LOAD_UNDELIVERED_MESSAGES_SUCCESSFUL'
export const GET_UNREAD_MESSAGES_PENDING = 'GET_UNREAD_MESSAGES_PENDING'
export const LOAD_UNREAD_MESSAGES_SUCCESSFUL = 'LOAD_UNREAD_MESSAGES_SUCCESSFUL'
